import { createEvent } from 'effector';

// * events
export const toggleShowCoverElementPartiesEvent = createEvent();
export const toggleShowCoverElementDateEvent = createEvent();
export const toggleShowCoverElementLogoEvent = createEvent();
export const onChangeCoverElementFieldsEvent = createEvent<{ index: number; value: string }>();
